/// <reference path="../../Common/Helpers/GridEditorBase.ts" />
namespace GeniuzPOS.AdvPromo {

    @Serenity.Decorators.registerClass()
    export class PsAdvPromoItem3Dialog extends Serenity.Extensions.GridEditorDialog<PsAdvPromoItem3Row> {

        // static from: string;
        protected getFormKey() { return PsAdvPromoItem3Form.formKey; }
        // protected getIdProperty() { return PsAdvPromoItem3Row.idProperty; }
        protected getLocalTextPrefix() { return PsAdvPromoItem3Row.localTextPrefix; }
        protected getNameProperty() { return PsAdvPromoItem3Row.nameProperty; }
        protected getService() { return PsAdvPromoItem3Service.baseUrl; }
        // protected getDeletePermission() { return PsAdvPromoItem3Row.deletePermission; }
        // protected getInsertPermission() { return PsAdvPromoItem3Row.insertPermission; }
        // protected getUpdatePermission() { return PsAdvPromoItem3Row.updatePermission; }

        protected form = new PsAdvPromoItem3Form(this.idPrefix);
        
        private pass: string

        public get Pass(): string { return this.pass }
        set Pass(value: string) { this.pass = value; }

        constructor() {
            super();
            


            this.form.FreeLpFg.changeSelect2(e => {
                this.FreeLpFgcheck();
                
            });

            this.form.PluCode.changeSelect2(e => {
                let Fg = Q.toId(this.form.PluCode.value)
                if (Fg != null) {
                    // this.form.ListFg.value = 1
                    this.form.StyleCode.value = null
                    this.form.CatCode.value = null
                    this.form.SubCat1Code.value = null
                    this.form.SubCat2Code.value = null
                    this.form.BrandCode.value = null
                    this.form.SupplCode.value = null
                }
                if (Fg = null) {
                    // this.form.ListFg.value = 2
                }
            });
            this.form.StyleCode.changeSelect2(e => {
                let Fg = Q.toId(this.form.StyleCode.value)
                if (Fg != null) {
                    // this.form.ListFg.value = 2
                    this.form.PluCode.value = null
                }
                
            });
            this.form.CatCode.changeSelect2(e => {
                let Fg = Q.toId(this.form.CatCode.value)
                if (Fg != null) {
                    // this.form.ListFg.value = 2
                    this.form.PluCode.value = null
                }
                
            });
            this.form.SubCat1Code.changeSelect2(e => {
                let Fg = Q.toId(this.form.SubCat1Code.value)
                if (Fg != null) {
                    // this.form.ListFg.value = 2
                    this.form.PluCode.value = null
                }
                
            });
            this.form.SubCat2Code.changeSelect2(e => {
                let Fg = Q.toId(this.form.SubCat2Code.value)
                if (Fg != null) {
                    // this.form.ListFg.value = 2
                    this.form.PluCode.value = null
                }
                
            });
            this.form.SupplCode.changeSelect2(e => {
                let Fg = Q.toId(this.form.SupplCode.value)
                if (Fg != null) {
                    // this.form.ListFg.value = 2
                    this.form.PluCode.value = null
                }
                
            });
            this.form.BrandCode.changeSelect2(e => {
                let Fg = Q.toId(this.form.BrandCode.value)
                if (Fg != null) {
                    // this.form.ListFg.value = 2
                    this.form.PluCode.value = null
                }
                
            });

            this.form.PmExtCode.changeSelect2(e => {
                let ex = Q.toId(this.form.PmExtCode.value)
                let gp = Q.toId(this.form.PmGroupId.value)
                this.form.PmId.value = ex + gp;
            });

            this.form.ListFg.changeSelect2(e => {
               
                this.ListFgCheck();
            });

        }
        // private get FreeLpFg1() {
        //     return this.form.FreeLpFg.value != "0";
        // }

        // private get FreeLpFg0() {
        //     return this.form.FreeLpFg.value != "1";
        // }



        // private get AssortFg1() {
        //     return this.form.AssortFg.value = "1";
        // }

        // private get AssortFg2() {
        //     return this.form.AssortFg.value = "2";
        // }



        protected getToolbarButtons(): Serenity.ToolButton[] {
            let buttons = super.getToolbarButtons();

            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "save-and-close-button"), 1);
            // buttons.splice(Q.indexOf(buttons, x => x.cssClass == "apply-changes-button"), 1);
            let newitem: Serenity.ToolButton =
            {
                title: "เพิ่ม&ใช้ข้อมูลเดิม",
                hint: "add and new [alt+s]",
                separator: false,
                cssClass: "button-addandnew",
                icon: "fa fa-save",
                hotkey: 'alt+s',
                onClick: () => {
                    var s = this.Checkbeforsave();
                    if (s) {

                    }

                    else {
                    Q.confirm('ยืนยันการเพิ่ม'
                    +"\r\n" +"โดยคงค่าข้อมูลเดิม และ Step no.+1"
                    , () => {

                    // e.preventDefault();
                    this.saveAndNew();
                    this.FreeLpFgcheck();
                    this.ListFgCheck();
                    
                    });}
                }
            };
            buttons.push(newitem);
            let newitem2: Serenity.ToolButton =
            {
                title: "เพิ่ม&สร้างใหม่",
                hint: "add and clear [alt+a]",
                separator: false,
                cssClass: "button-addandclear",
                icon: "fa fa-save",
                hotkey: 'alt+a',
                onClick: (e) => {
                    var s = this.Checkbeforsave();
                    if (s) {

                    }

                    else {
                    
                    e.preventDefault();
                    Q.confirm('ยืนยันการเพิ่ม และสร้างรายการใหม่ทั้งหมด'
                    +"\r\n" +"โดย ล้างรายการที่ป้อนทั้งหมด", () => {

                    this.saveAndclear();
                    this.FreeLpFgcheck();
                    this.ListFgCheck();
                    // this.dialogClose();
                    });}
                }
            };
            buttons.push(newitem2);

            buttons.push(
                {
                    title: Q.text("Close"),	// *** Get button text from translation
                    cssClass: '.panel-titlebar-close',
                    icon: 'fa-close',
                    hint: 'esc',
                    hotkey: 'esc',
                    onClick: () => {
                        this.dialogClose();
                        // *** do something on click if you want **

                    },
                }
            );
            return buttons;
        }
        private saveAndNew() {
            let e = this.entity; let f = this.form;
            if (f.PmStepNo == null) {
                var pmstep = f.PmStepNo.value;
            }else{
                var pmstep = f.PmStepNo.value+1;
            }
            this.save((response) => {
                let ent: PsAdvPromoItem3Row = { 
                    PmGroupId: f.PmGroupId.value,
                    PmId:f.PmId.value, 
                    PmType:f.PmType.value,
                    PmExtCode: f.PmExtCode.value,
                    PmStepNo: pmstep,
                    PmDesc: f.PmDesc.value,

                    // ItemType: Number(f.ItemType.value),
                    AssortFg: Number(f.AssortFg.value),
                    // Qty: f.Qty.value,
                    Amt: f.Amt.value,
                    FreeLpFg: Number(f.FreeLpFg.value),
                    DiscPc: f.DiscPc.value,
                    DiscAmt: f.DiscAmt.value,

                    ListFg: Number(f.ListFg.value),
                    PluCode: f.PluCode.value,
                    StyleCode: f.StyleCode.value,
                    BrandCode: f.BrandCode.value,
                    CatCode: f.CatCode.value,
                    SubCat1Code: f.SubCat1Code.value,
                    SubCat2Code: f.SubCat2Code.value,
                    SupplCode: f.SupplCode.value
                };
                this.loadEntity(ent);
            });
            
        }
        private saveAndclear() {
            let e = this.entity; let f = this.form;
            // if (e.SkuCode == null) {
            //     e.SkuCode = f.SkuCode.value;

            // }
            this.save((response) => {
                let ent: PsAdvPromoItem3Row = { 
                    PmGroupId: e.PmGroupId,
                    PmType:e.PmType
                    
                };
                this.loadEntity(ent);
            });
            
        }



        protected afterLoadEntity() {
            super.afterLoadEntity();
            if (this.isNew()) {
                this.form.PmGroupId.value = this.pass

                Serenity.EditorUtils.setReadOnly(this.form.DiscPc, false);
                Serenity.EditorUtils.setReadOnly(this.form.DiscAmt, true);
            }
            
            else {
                this.FreeLpFgcheck();
                this.ListFgCheck();
            }

        }

        private FreeLpFgcheck(){
            let Fg = Q.toId(this.form.FreeLpFg.value)

                
                if (Fg == 1) {
                    // Serenity.EditorUtils.setReadOnly(this.form.NpcsOrBundlePrice, true);
                    Serenity.EditorUtils.setReadOnly(this.form.DiscPc, false);
                    Serenity.EditorUtils.setReadOnly(this.form.DiscAmt, true);
                    // this.form.NpcsOrBundlePrice.value = null
                    this.form.DiscAmt.value = null
                }
                if (Fg == 2) {
                    // Serenity.EditorUtils.setReadOnly(this.form.NpcsOrBundlePrice, true);
                    Serenity.EditorUtils.setReadOnly(this.form.DiscPc, true);
                    Serenity.EditorUtils.setReadOnly(this.form.DiscAmt, false);
                    // this.form.NpcsOrBundlePrice.value = null
                    this.form.DiscPc.value = null

                }
        }

        private ListFgCheck() {
            let ex = Q.toId(this.form.ListFg.value)
            if (ex == 2) {
                Serenity.EditorUtils.setReadOnly(this.form.PluCode, true);

                Serenity.EditorUtils.setReadOnly(this.form.StyleCode, false);
                Serenity.EditorUtils.setReadOnly(this.form.CatCode, false);
                Serenity.EditorUtils.setReadOnly(this.form.SubCat1Code, false);
                Serenity.EditorUtils.setReadOnly(this.form.SubCat2Code, false);
                Serenity.EditorUtils.setReadOnly(this.form.BrandCode, false);
                Serenity.EditorUtils.setReadOnly(this.form.SupplCode, false);
                this.form.PluCode.value = null
            }
            if (ex == 1) {
                Serenity.EditorUtils.setReadOnly(this.form.StyleCode, true);
                Serenity.EditorUtils.setReadOnly(this.form.CatCode, true);
                Serenity.EditorUtils.setReadOnly(this.form.SubCat1Code, true);
                Serenity.EditorUtils.setReadOnly(this.form.SubCat2Code, true);
                Serenity.EditorUtils.setReadOnly(this.form.BrandCode, true);
                Serenity.EditorUtils.setReadOnly(this.form.SupplCode, true);

                Serenity.EditorUtils.setReadOnly(this.form.PluCode, false);
                this.form.StyleCode.value = null
                this.form.CatCode.value = null
                this.form.SubCat1Code.value = null
                this.form.SubCat2Code.value = null
                this.form.BrandCode.value = null
                this.form.SupplCode.value = null
            }
            if (ex == 0) {
                Serenity.EditorUtils.setReadOnly(this.form.StyleCode, true);
                Serenity.EditorUtils.setReadOnly(this.form.CatCode, true);
                Serenity.EditorUtils.setReadOnly(this.form.SubCat1Code, true);
                Serenity.EditorUtils.setReadOnly(this.form.SubCat2Code, true);
                Serenity.EditorUtils.setReadOnly(this.form.BrandCode, true);
                Serenity.EditorUtils.setReadOnly(this.form.SupplCode, true);
                Serenity.EditorUtils.setReadOnly(this.form.PluCode, true);
                this.form.StyleCode.value = null
                this.form.CatCode.value = null
                this.form.SubCat1Code.value = null
                this.form.SubCat2Code.value = null
                this.form.BrandCode.value = null
                this.form.SupplCode.value = null
                this.form.PluCode.value = null
            }
        }


        private Checkbeforsave() {

            if (this.form.FreeLpFg.value == "2" && this.form.DiscAmt.value == null) {
                Q.warning("โปรด ใส่ส่วนลด");
                return true
            }

            else if (this.form.FreeLpFg.value == "1" && this.form.DiscPc.value == null) {
                Q.warning("โปรด ใส่ส่วนลด");
                return true
            }

           
            else {
                if (this.form.ListFg.value == "1" && this.form.PluCode.value == "") {
                    Q.warning("โปรด เลือกสินค้า")
                    return true
                }
                else if (this.form.ListFg.value == "2" &&
                    this.form.StyleCode.value == "" && this.form.CatCode.value == ""
                    && this.form.SubCat1Code.value == "" && this.form.SubCat2Code.value == ""
                    && this.form.BrandCode.value == "" && this.form.SupplCode.value == "") {
                    Q.warning("โปรด ระบุเกณฑ์สินค้า")
                    return true
                }
                else {
                    return false
                }
            }





        }

    }
}